export const _setCboRteStartMthId = (state, action) => {
  state.Start = action.payload;
};

export const _setCboRteEndMthId = (state, action) => {
  state.End = action.payload;
};

export const _setCboRteTmtTypId = (state, action) => {
  state.TmtType = action.payload;
};

export const _setCboRteAmt = (state, action) => {
  state.Amount = action.payload;
};

export const _setCbpCnyMnRte = (state, action) => {
  state.DARSApprovedCountRteMn = action.payload;
};

export const _setCbpCnyMxRte = (state, action) => {
  state.DARSApprovedCountRteMx = action.payload;
};

export const _setCboRteDcpUnitAmt = (state, action) => {
  state.UnitsPerDay = action.payload;
};

export const _setCboDefaultWeeklyQty = (state, action) => {
  state.UnitsPerWeek = action.payload;
};

export const _setCboRteDcpQty = (state, action) => {
  state.TotalUnits = action.payload;
};

export const _setCboRteDcpAmt = (state, action) => {
  state.TotalAmount = action.payload;
};

export const _setCboRteTargetPct = (state, action) => {
  state.UtilizationReq = action.payload;
};

export const _setCboRteCmt = (state, action) => {
  state.Comment = action.payload;
};

export const _setCbpRteInactive = (state, action) => {
  state.RateInactive = action.payload;
};

export const _setCboRteDcpMthSettlementYn = (state, action) => {
  state.MonthlySettlement = action.payload;
};
